import type { CSSProperties, ReactNode } from 'react';
import { v } from '@/theme/tokens';

interface CardProps {
  children: ReactNode;
  style?: CSSProperties;
  padding?: number;
}

/** A surface that carries data. Its material (opaque in the classic skin,
 * a dense glass in the glass one) lives in styles/glass.css (`.rt-card`):
 * amounts, tables and charts sit on it, so it never becomes see-through. */
export function Card({ children, style, padding = 20 }: CardProps) {
  return (
    <div className="rt-card" style={{ padding, ...style }}>
      {children}
    </div>
  );
}

export function SectionTitle({ children, right }: { children: ReactNode; right?: ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        marginBottom: 14,
        // A caption and its badge wrap instead of pushing the card wider.
        flexWrap: 'wrap',
        gap: 8,
      }}
    >
      <div
        style={{
          fontSize: 13,
          fontWeight: 600,
          letterSpacing: 0.3,
          textTransform: 'uppercase',
          color: v('ink-muted'),
          minWidth: 0,
          overflowWrap: 'anywhere',
        }}
      >
        {children}
      </div>
      {right}
    </div>
  );
}
